import Vue from 'vue'
import App from './App'
import routerDev from './router/lazy'
import routerPro from './router/lazy_pro'
import '@/components/Common/index.js'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import Viser from 'viser-vue'
import axios from 'axios'
import store from './store'
import '@/assets/myfonts/iconfont.css'
import util from '@/utils/utils_width.js'
import './plugins/utils'
import './plugins/table'
import './plugins/plugin.scss'
import moment from 'moment'
import excelUtils from '@/utils/excelUtils'
//引入工具，配置代理
Vue.prototype.$excelUtils = excelUtils
Vue.prototype.$utilHelper = util
Vue.prototype.$utilMoment = moment
import loginDingUitl from '@/utils/loginUtils'
Vue.prototype.$loginDingUitl = loginDingUitl

import './permission.js' // permission control
import 'babel-polyfill'
//然后再修改原型链
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(Viser)
Vue.use(Antd)
let router = routerPro
// 判断 环境是否满足
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'development') {
  router = routerDev
}
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {},
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js